module.exports = __webpack_public_path__ + "img/thanq_logo1.299226fc.svg";